import config from "@/config/config";

import Index from "@/pages/config/payment-type/index.vue";
import List from "@/pages/config/payment-type/list/list.vue";
import View from "@/pages/config/payment-type/view/view.vue";
import New from "@/pages/config/payment-type/new/new.vue";
import Edit from "@/pages/config/payment-type/edit/edit.vue";

const modulePermission = config.modules.paymentType;

export default {
  path: "/payment-type",
  name: "payment-type",
  component: Index,
  meta: {
    requiresAuth: true,
    modulePermission: modulePermission,
    requiresPermission: "enabled_read",
  },
  children: [
    {
      path: "list",
      name: "payment-type-list",
      component: List,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: "enabled_read",
      },
    },
    {
      path: ":id",
      name: "payment-type-view",
      component: View,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: "enabled_read",
      },
      props: true,
    },
    {
      path: "new",
      name: "payment-type-new",
      component: New,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: "enabled_create",
      },
    },
    {
      path: ":id/e",
      name: "payment-type-edit",
      component: Edit,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: "enabled_edit",
      },
      props: true,
    },
  ],
};
